import { render } from "./header.vue?vue&type=template&id=547c23ba"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=547c23ba&lang=css"
script.render = render

export default script